import { HosesWorkOrder } from './work-order';
import { SchedulerSubWorkOrder } from '../../../common/scheduler/models/sub-work-order';

export class HosesSubWorkOrder extends SchedulerSubWorkOrder {
  workOrder: HosesWorkOrder;
  get quantityRequired(): number {
    return this.workOrder.quantityRequired;
  }

  get quantityBuilt(): number {
    return this.workOrder.quantityBuilt;
  }

  set quantityBuilt(value: number) {
    this.workOrder.quantityBuilt = value;
  }

  get builtReport(): number {
    return this.workOrder.builtReport;
  }

  set builtReport(value: number) {
    this.workOrder.builtReport = value;
  }

  get transactionNumber(): string {
    return this.workOrder.transactionNumber;
  }

  get assemblyTitle(): string {
    return this.workOrder.assemblyItem.title;
  }

  get endDate(): Date {
    return this.workOrder.endDate;
  }

  get producedPlusOnValidation(): number {
    return this.workOrder.producedPlusOnValidation;
  }

  get assemblyType(): string {
    return this.workOrder.assemblyType;
  }

  static fromObject(object: SchedulerSubWorkOrder): HosesSubWorkOrder {
    const newObj = new HosesSubWorkOrder();
    const workOrder = HosesWorkOrder.fromObject(object.workOrder);
    Object.assign(newObj, object);
    newObj.workOrder = workOrder;
    return newObj;
  }

  static transformToWorkOrder(obj: SchedulerSubWorkOrder): HosesWorkOrder {
    const item = new HosesSubWorkOrder();
    Object.assign(item, obj);
    item.workOrder = new HosesWorkOrder();
    Object.assign(item.workOrder, obj.workOrder);
    item.workOrder.subWorkOrders = [item];
    item.workOrder.qcSubWorkOrder = item;
    return item.workOrder;
  }
}
